<div class="" fxLayout="column" fxLayoutAlign="start center">
<ng-container *ngIf="data.tipo==1">
  <h2 mat-dialog-title>Información del líder</h2>
  <mat-tab-group class="mat-tab-group">
  <mat-tab label="Datos">
    <div class="" fxLayout="column" fxLayoutAlign="space-between stretch">
      <div class="mt-20" fxLayout="row" fxLayoutAlign="space-between stretch">
        <mat-form-field appearance="outline" fxFlex="30">
          <mat-label>Nombre del líder</mat-label>
          <input matInput [value]="data.datos.fullName">
          <mat-icon matSuffix>account_circle</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="30">
          <mat-label>Correo</mat-label>
          <input matInput [value]="data.datos.email">
          <mat-icon matSuffix>alternate_email</mat-icon>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="30">
          <mat-label>Area:</mat-label>
          <input matInput [value]="data.datos.area">
          <mat-icon matSuffix>location_city</mat-icon>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between start">
      <div class="example-container">
  <h2>Cupones asignados</h2>
  <mat-card>
    <div
    cdkDropList
    #todoList="cdkDropList"
    [cdkDropListData]="todo"
    [cdkDropListConnectedTo]="[doneList]"
    class="example-list"
    (cdkDropListDropped)="drop($event)">
    <div class="example-box" *ngFor="let item of todo" cdkDrag>
      <div class="" fxLayout="row" fxLayoutAlign="space-between start">
        <p>{{item.cuponName}}</p>
        <mat-icon matSuffix style="color:#8CC972">confirmation_number</mat-icon>
      </div>
    </div>
  </div>
  </mat-card>
</div>

<div class="example-container" >
  <h2>Cupones por asignar </h2>
  <mat-card>
    <div
    cdkDropList
    #doneList="cdkDropList"
    [cdkDropListData]="done"
    [cdkDropListConnectedTo]="[todoList]"
    class="example-list"
    (cdkDropListDropped)="drop($event)">
    <div class="example-box" *ngFor="let item of done" cdkDrag>
      <div class="" fxLayout="row" fxLayoutAlign="space-between start">
        <p>{{item.cuponName}}  </p>
        <mat-icon matSuffix style="color:#8CC972">confirmation_number</mat-icon>
      </div>
    </div>
  </div>
  </mat-card>
</div>
</div>

    </div>
  </mat-tab>
  <mat-tab label="Avance"> Content 2 </mat-tab>
</mat-tab-group>


</ng-container>
<ng-container *ngIf="data.tipo==2">
  <h2 mat-dialog-title>registro de un nuevo líder</h2>
</ng-container>
<button mat-raised-button color="accent" class="mt-20" (click)="salir()">
  Cerrar
<mat-icon class="ml-20">clear</mat-icon>
</button>
</div>
